import { render, staticRenderFns } from "./SolutionConsult.vue?vue&type=template&id=40f0939f&scoped=true"
import script from "./SolutionConsult.vue?vue&type=script&lang=js"
export * from "./SolutionConsult.vue?vue&type=script&lang=js"
import style0 from "./SolutionConsult.vue?vue&type=style&index=0&id=40f0939f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f0939f",
  null
  
)

export default component.exports